import {ValidationErrorKeys} from '@hconnect/common/consts'
import {TFunction} from 'i18next'
import {object, string} from 'yup'

const COMMENT_MAX_LENGTH = 1000

export const getSlaCommentValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    comment: string()
      .trim()
      .max(COMMENT_MAX_LENGTH, t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH}))
      .required(t(ValidationErrorKeys.REQUIRED))
  })
